module.exports = __webpack_public_path__ + "img/source_mg-04.6bb40eb9.png";